<template>
    <div class="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    created() {
        // console.log(this.$route.query);
        if (!this.$route.query.forceIframe) {
            window.addEventListener('resize', () => {
                this.checkType();
            });

            this.checkType();
        }
    },
    methods: {
        checkType() {
            if (window.innerWidth <= 1000 && this.$route.name === 'desktop') {
                this.$router.push({
                    name: 'home',
                });
            } else if (window.innerWidth > 1000 && this.$route.name === 'home') {
                this.$router.push({
                    name: 'desktop',
                });
            }
        },
    },
};
</script>
